<template>
  <v-dialog persistent v-model="visible" max-width="800px">
    <v-card>
      <v-card-title
        class="headline font-weight-medium white--text"
        style="background-color: #0b4f6a;"
      >
        TERMOS DE ACEITE
      </v-card-title>
      <div class="card-wrapper">
        <v-card-text class="content">
          <div class="texto-termos">
            <p><strong>Atenção:</strong> É fundamental que todas as informações fornecidas na formação do contrato de seguro sejam completas e precisas.<br> 
              O descumprimento do dever pode resultar na perda de direitos ou na anulação do contrato.<br> 
              Caso tenha dúvidas sobre quais informações são relevantes, consulte nosso atendimento.
            </p> 
              
              <p>Veja a relação de RISCOS E BENS EXCLUÍDOS do produto SEGURO AUTO FROTA constantes do site da Essor Seguros pelo link: 
                <a href="http://www.essor.com.br/condicoes-gerais/#tab-2" target="_blank">http://www.essor.com.br/condicoes-gerais/#tab-2</a> 
              </p>

              <p>Em caso de discordância, entre as informações prestadas pelo segurado na cotação e na proposta de seguros, prevalecerão as informações constantes na proposta de seguros.</p>
          </div>

          <label class="aceite"> 
            <input type="checkbox" v-model="aceito" /> Declaro ciência em relação aos itens acima descritos e manterei o segurado devidamente esclarecido quanto aos mesmos. 
          </label>
        </v-card-text>
      
        <v-card-actions class="actions"> 
          <v-btn @click="fechar" flat	class="btn-cancel">Cancelar</v-btn> 
          <v-btn :disabled="!aceito" class="btn-proximo" @click="proximo"> Próximo </v-btn> 
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalTermosAceite',
  data() {
    return {
      aceito: false,
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    fechar() { 
      this.$emit('close'); 
    }, 
    proximo() { 
      this.$emit('next'); 
    },
  }
};
</script>

<style scoped>
.actions {
  padding: 1.25rem 1.625rem 1.625rem 1.625rem !important;
  justify-content: flex-end;
  gap: 0.75rem;
}
.card-wrapper{
  background-color: #EAEAEA;
}
.content {
  padding: 1.25rem 5.625rem 1.25rem 5.625rem;
}

.texto-termos p {
  margin-bottom: 0.875rem;
}

.btn-proximo {
  background-color: #0b4f6a !important;
  color: white !important;
}

.v-btn.btn-cancel,
.v-btn.btn-cancel .v-btn__content {
  color: #0b4f6a !important;
  text-transform: uppercase;
  font-weight: 600;
}

.aceite {
  display: flex;
  gap: 0.625rem;
  margin-top: 1rem;
  font-size: 1rem;
  padding: 0.625rem 3.125rem 0.625rem 3.125rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/solicitacao-cotacao-analista/ModalTermosAceite.vue